import { getDimensions } from 'reporting-data/report/configReportGetters';
export const reportConfigProcessor = report => {
  let processedReport = report;
  processedReport = processedReport.set('name', '');
  processedReport = processedReport.set('id', 0);
  processedReport = processedReport.set('templateKey', '');
  processedReport = processedReport.set('visualization', null);
  return processedReport;
};
export const defaultStoryReportConditionChecker = (report, dataset) => !!getDimensions(report).size && !!dataset && !!dataset.get('data').length;